/* eslint-disable import/prefer-default-export */
import React from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { setShowContextMenu } from 'store/ManageGeneral/actions';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import copyToClipboard from 'utils/clipboard';
import { CopyLinkIcon } from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/styled';
import { selectVulnsSelected } from 'store/ManageGeneral/selectors';

export const CopyLink = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const vulnsSelected = useSelector(selectVulnsSelected);
  const isBulk = vulnsSelected.length > 1;
  const vulnId = get(vulnsSelected, '[0]._id', 0);
  const link = get(window, 'location.href', '');

  const onClick = () => {
    copyToClipboard(`${link}/${vulnId}`);
    dispatch(setShowContextMenu(false));
  };

  if (isBulk) return null;
  return (
    <MenuItem
      title={ intl.formatMessage({ id: 'manage.cm.copyLink' }) }
      icon={ <CopyLinkIcon /> }
      onClick={ onClick }
    />
  );
};
